import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, DatePicker, Select, Button, Table, Space, Modal, Tooltip } from "antd";
import "./goods_receive.css";
import { withGoodsReceiveLogic, GoodsReceiveProps, PoItemDataType, itemGroupOptions } from "../../components/hoc_goods_receive";
import DataPoForGoodsReceive from "./data_po_for_goods_receive";
import EditTableGoodsReceive from "./edit_table_goods_receive";
import AddLineForGR from "./add_line_for_goods_receive";

const GoodsReceive: React.FC<GoodsReceiveProps> = ({
    onDateChange,
    onChange,
    onItemGroupChange,
    columns,
    rowSelection,
    isModalOpen,
    showModal,
    handleCancel,
    poData,
    form,
    onSelectPo,
    tableDataSource,
    isEditModalOpen,
    handleEditCancel,
    selectedPoItemForEdit,
    onRowDoubleClick,
    onUpdatePoItem,
    onSelectLocationCode,
    isAddLineModalOpen,
    showAddLineModal,
    handleAddLineCancel,
    refDocumentNo,
    onAddLineItems,
    onDeleteSelectedItems,
    initialSelectedAddLineKeys,
    autosaveStatus,
    existingGrPoNos,
    tableSummary,
    onVoid,
    onSubmit,
    onPrint,
    warehouseData,
    printLoading,
    printProgress,
    submitLoading,
    lockedFields,
    onFieldFocus,
    onFieldBlur,
    onFormValuesChange,
    getLockProps 

}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const currentStatus = Form.useWatch('status', form);
    const refDocumentNoValue = Form.useWatch('ref_document_no', form);
    const itemGroupValue = Form.useWatch('item_group', form);
    const isVoidButtonDisabled = !(currentStatus === '1' || currentStatus === 'Draft');
    const isAutosaving = autosaveStatus === 'processing';

    return (

        <div id="iau9-gr" style={transformStyle}>
            <div className="gjs-grid-row" id="ifrfo">
                <div className="gjs-grid-column" id="isb14">
                    <Breadcrumb
                        items={[
                            {
                                href: "#/dashboard/data_goods_receive",
                                title: (
                                    <>
                                        <span>Data Goods Receive</span>
                                    </>
                                ),
                            },
                            {
                                title: "Goods Receive",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="xvcgdj">
                <div className="gjs-grid-column" id="hhhfdk">
                    <Button className="gr-button" disabled={isAutosaving}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z"
                                clipRule="evenodd"
                            />
                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                        </svg>
                        New
                    </Button>
                    <Button className="gr-button" onClick={onSubmit} loading={submitLoading} disabled={!(currentStatus === '1' || currentStatus === 'Draft') || isAutosaving}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Submit
                    </Button>
                    <Button className="gr-button"
                        onClick={onVoid}
                        disabled={isVoidButtonDisabled || isAutosaving}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Void
                    </Button>
                    <Button className="gr-button" onClick={onPrint} loading={printLoading} disabled={isAutosaving}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>
            <div className="gjs-grid-row" id="iachd">
                <div className="gjs-grid-column" id="ivi1h">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '190px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        form={form}
                        onValuesChange={onFormValuesChange}
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("status")}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Goods Receive No"
                            name="goods_receive_no"
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("goods_receive_no")}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Date"
                            name="date"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                            {...getLockProps("date")}
                        >
                            <DatePicker
                                disabled={!!lockedFields?.["date"]}
                                onOpenChange={(open) => open ? onFieldFocus("date") : onFieldBlur("date")}
                                onChange={onDateChange}
                                format="DD/MM/YYYY"
                                placeholder="Select date"
                                style={{ width: "40%", fontSize: "14px" }}
                                popupStyle={{ fontSize: "12px" }}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Item Group"
                            name="item_group"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                            {...getLockProps("item_group")}
                        >
                            <Select
                                disabled={!(currentStatus === 'Draft' || currentStatus === '1') || !!lockedFields?.["item_group"]}
                                onDropdownVisibleChange={(open) => open ? onFieldFocus("item_group") : onFieldBlur("item_group")}
                                showSearch
                                placeholder="Select Group"
                                optionFilterProp="label"
                                onChange={onItemGroupChange}
                                options={itemGroupOptions}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Reference Type"
                            name="reference_type"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                            {...getLockProps("reference_type")}
                        >
                            <Select
                                disabled={!!lockedFields?.["reference_type"]}
                                onDropdownVisibleChange={(open) => open ? onFieldFocus("reference_type") : onFieldBlur("reference_type")}
                                showSearch
                                placeholder="Select Reference Type"
                                optionFilterProp="label"
                                onChange={onChange}
                                options={[
                                    { value: "1", label: "Part Claim" },
                                    { value: "2", label: "Purchase Order" },
                                    { value: "3", label: "Warranty Claim" },
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Ref. Document No."
                            name="ref_document_no"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                            {...getLockProps("ref_document_no")}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Input
                                    placeholder=""
                                    style={{
                                        width: "90%",
                                    }}
                                    value={refDocumentNoValue || form.getFieldValue('ref_document_no')}
                                    readOnly
                                />

                                <Button
                                    type="primary"
                                    id="data_po_for_goods_receive"
                                    onClick={showModal}
                                    disabled={!itemGroupValue || !!refDocumentNoValue || isAutosaving || !!lockedFields?.["ref_document_no"]}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{
                                                width: "22px",
                                                height: "22px",
                                            }}
                                        >
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                />
                            </div>

                        </Form.Item>
                        <Form.Item
                            label="Supplier Invoice No."
                            name="supplier_invoice_no"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                            {...getLockProps("supplier_invoice_no")}
                        >
                            <Input
                                placeholder=""
                                disabled={!!lockedFields?.["supplier_invoice_no"]}
                                onFocus={() => onFieldFocus("supplier_invoice_no")}
                                onBlur={() => onFieldBlur("supplier_invoice_no")}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Tax Invoice No"
                            name="tax_invoice_no"
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("tax_invoice_no")}
                        >
                            <Input
                                placeholder=""
                                disabled={!!lockedFields?.["tax_invoice_no"]}
                                onFocus={() => onFieldFocus("tax_invoice_no")}
                                onBlur={() => onFieldBlur("tax_invoice_no")}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder="Select Warehouse"
                                optionFilterProp="label"
                                options={warehouseData.map(wh => ({ value: wh.warehouse_code, label: wh.warehouse_name }))}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                disabled
                            />
                        </Form.Item>
                        <Form.Item
                            label="Via Expedition"
                            name="via_expedition"
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("via_expedition")}
                        >
                            <Input
                                placeholder=""
                                disabled={!!lockedFields?.["via_expedition"]}
                                onFocus={() => onFieldFocus("via_expedition")}
                                onBlur={() => onFieldBlur("via_expedition")}
                            />
                        </Form.Item>
                        <Form.Item
                            label="No Delivery"
                            name="no_delivery"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                            {...getLockProps("no_delivery")}
                        >
                            <Input
                                placeholder=""
                                disabled={!!lockedFields?.["no_delivery"]}
                                onFocus={() => onFieldFocus("no_delivery")}
                                onBlur={() => onFieldBlur("no_delivery")}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("remark")}
                        >
                            <Input.TextArea
                                rows={4}
                                disabled={!!lockedFields?.["remark"]}
                                onFocus={() => onFieldFocus("remark")}
                                onBlur={() => onFieldBlur("remark")}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </div>

            <div className="gjs-grid-row" id="iieaj">
                <div className="gjs-grid-column" id="i8c9p">
                    <Table<PoItemDataType>
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={tableDataSource}
                        scroll={{ x: 'max-content' }}
                        className="table-gr"
                        rowClassName={(record) => (lockedFields?.[`row_${record.key}`] ? "table-row-locked" : "")}
                        onRow={(record) => {
                            return {
                                onDoubleClick: () => {
                                    onRowDoubleClick(record);
                                },
                            };
                        }}
                        summary={tableSummary}
                    />
                    <div style={{ marginTop: "20px", textAlign: "left" }}>
                        <Space>
                            <Button
                                type="primary"
                                id="add_line_for_goods_receive"
                                style={{
                                    height: "40px",
                                    width: "105px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                onClick={showAddLineModal}
                                disabled={isAutosaving || !!lockedFields?.["table_add_line"]}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                            >
                                Add Line
                            </Button>
                            <Button
                                type="primary"
                                id="delete_data_tabel_GR"
                                style={{
                                    height: "40px",
                                    width: "90px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                onClick={onDeleteSelectedItems}
                                disabled={isAutosaving || ((rowSelection?.selectedRowKeys || []) as React.Key[]).some((key: React.Key) => !!lockedFields?.[`row_${key}`])}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                    </svg>
                                }
                            >
                                Delete
                            </Button>
                        </Space>
                    </div>
                </div>
            </div>
            <Modal
                title="Purchase Order Data"
                open={isModalOpen}
                onOk={handleCancel}
                onCancel={handleCancel}
                width={1000}
                footer={null}
            >
                <DataPoForGoodsReceive
                    poData={poData}
                    onSelectPo={onSelectPo}
                    currentRefDocumentNo={refDocumentNo}
                    existingGrPoNos={existingGrPoNos}
                />
            </Modal>
            <Modal
                className="modal-edit"
                title="edit Detail"
                open={isEditModalOpen}
                onOk={handleEditCancel}
                onCancel={handleEditCancel}
                maskClosable={true}
                width={450}
                footer={null}
            >
                <EditTableGoodsReceive
                    selectedPoItem={selectedPoItemForEdit}
                    onUpdateItem={onUpdatePoItem}
                    onSelectLocationCode={onSelectLocationCode}
                    goodsReceiveNo={form.getFieldValue("goods_receive_no")}
                    refDocumentNo={refDocumentNo}
                    onCancel={handleEditCancel}
                    warehouse={form.getFieldValue("warehouse")}
                />
            </Modal>
            <Modal
                title="Add Line"
                open={isAddLineModalOpen}
                onOk={handleAddLineCancel}
                onCancel={handleAddLineCancel}
                width={1000}
                footer={null}
            >
                <AddLineForGR
                    poNo={refDocumentNo}
                    onAddItems={onAddLineItems}
                    existingItems={tableDataSource}
                    initialSelectedKeys={initialSelectedAddLineKeys}
                />
            </Modal>
        </div>
    );
};

export default withGoodsReceiveLogic(GoodsReceive);
